import React from "react";
import { Routes, Route, Navigate, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import { canAccessAdmin } from "@/utils/roles";

import Pilotage from "./pilotage";
import Recouvrement from "@/scenes/cashout/recouvrement";

// Section Admin — un onglet par page. L'accès est filtré ici, une seule fois : les pages
// elles-mêmes n'ont plus de garde, elles ne sont atteignables que par ce routeur.
// Trois onglets (décision Seb, 29/09) : les deux lectures du plan à gauche, et à droite le
// recouvrement — c'est d'où vient le cash du plan, mais ça se travaille facture par facture.
// Overview et Budgets Selego ont été retirés ; leurs anciennes URL retombent sur le PNL.
const tabItems = [
  { href: "pilotage/pnl", title: "PNL" },
  { href: "pilotage/treso", title: "Tréso" },
  { href: "recouvrement", title: "Recouvrement", right: true },
];

export default function Admin() {
  const user = useSelector((state) => state.Auth.user);

  if (!canAccessAdmin(user)) return <Navigate to="/" replace />;

  return (
    <div className="px-4">
      <nav className="my-1 rounded-md flex items-center gap-1 border border-neutral-300 bg-white p-1">
        {tabItems.map((item) => (
          <NavLink
            key={item.href}
            to={`/admin/${item.href}`}
            className={({ isActive }) => `${isActive ? "blue-btn" : "transparent-btn cursor-pointer relative rounded flex items-center"} ${item.right ? "ml-auto" : ""}`}
          >
            <div className="flex items-center gap-2 truncate">{item.title}</div>
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route path="/" element={<Navigate to="pilotage/pnl" replace />} />
        <Route path="/recouvrement" element={<Recouvrement embedded />} />
        <Route path="/pilotage" element={<Navigate to="/admin/pilotage/pnl" replace />} />
        <Route path="/pilotage/:tab" element={<Pilotage />} />
        {/* Anciens onglets retirés : les liens et signets existants retombent sur le PNL. */}
        <Route path="/overview" element={<Navigate to="/admin/pilotage/pnl" replace />} />
        <Route path="/budget" element={<Navigate to="/admin/pilotage/pnl" replace />} />
      </Routes>
    </div>
  );
}
